<template>
  <div class="drawer">
    <div class="drawer-container">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClickTab"
        v-loading="loading"
      >
        <el-tab-pane :label="$t('text.baseInfo')" name="detail">
          <div class="drawer-content with-tab">
            <el-form
              ref="orderForm"
              :model="order"
              class="box"
              label-width="80px"
            >
              <fieldset class="mgb15">
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('order.serialNo')">
                      <span v-if="order.hurry" class="red">
                        ({{ $t("order.hurrySimple") }}) </span
                      >{{ order.serialNo }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.innerSerialNo')">
                      {{ order.innerSerialNo }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.workflowState')">
                      <state-label
                        :state="order.workflowState"
                        :permit="Permit.canActions('orderDealView')"
                      >
                        <span v-if="Permit.canActions('orderDealView')">{{
                          $t("orderStates." + order.workflowState)
                        }}</span>
                        <span v-else>{{
                          $t("orderStatesNoPermit." + order.workflowState)
                        }}</span>
                      </state-label>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('text.createAt')">
                      {{ order.createAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.handOverAt')">
                      {{ order.handOverAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.confirmAt')">
                      {{ order.confirmAt }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('order.finishAt')"
                      label-width="100px"
                    >
                      {{ order.finishAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('menu.customers')">
                      {{ order.customerName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.dealSuggest')">
                      {{ order.dealSuggest }}
                    </el-form-item>
                  </el-col>
                  <el-col v-if="bargain.settleType == 'later'" :span="8">
                    <el-form-item :label="$t('order.settlement')">
                      <span v-if="order.settlementId == null">
                        {{ $t("boolean.false") }}
                      </span>
                      <span v-if="order.settlementId != null">
                        {{ $t("boolean.true") }}
                      </span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="mgb15">
                <legend>
                  {{ $t("order.productInfo") }}
                  <a
                    v-if="order.attachment"
                    class="fr blue"
                    target="_blank"
                    :href="order.attachment"
                  >
                    {{ $t("action.downloadAttatchment") }}
                  </a>
                </legend>

                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('product.productNo')">
                      {{ order.productNo }}
                      <small
                        v-if="
                          order.customerProductNo != null &&
                          order.customerProductNo != ''
                        "
                      >
                        ({{ order.customerProductNo }})
                      </small>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.category')">
                      {{ order.categoryName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.brand')">
                      {{ order.productBrand }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('product.color')">
                      <span class="float-left mgr5">{{ order.color }}</span>
                      <thumbnail
                        class="mgt5"
                        v-if="order.colorImage != null"
                        :images="order.colorImage"
                        width="25"
                        height="25"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.size')">
                      {{ order.size }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.quantity')">
                      {{ order.quantity }} {{ order.unit }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="Permit.canActions('globalSalePrice')">
                  <el-col :span="8" v-if="order.isScore == true">
                    <el-form-item :label="$t('product.score')">
                      {{ order.score }}
                    </el-form-item>
                  </el-col>
                  <template v-else>
                    <el-col :span="8">
                      <el-form-item :label="$t('order.productPrice')">
                        <currency :code="order.currency"></currency>
                        {{ order.productPrice }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('order.price')">
                        <currency :code="order.currency"></currency>
                        {{ order.price }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('order.extraCharge')">
                        <currency
                          v-if="
                            order.extraCharge != null && order.extraCharge != 0
                          "
                          :code="order.currency"
                        ></currency>
                        {{ order.extraCharge }}
                      </el-form-item>
                    </el-col>
                  </template>
                </el-row>
              </fieldset>
              <fieldset
                v-if="
                  order.specJson != null &&
                  order.specJson != '' &&
                  JSON.parse(order.specJson).length != 0
                "
                class="mgb15"
              >
                <legend>{{ $t("product.specJson") }}</legend>
                <el-tag
                  v-for="s in JSON.parse(order.specJson)"
                  :key="s.name"
                  type="info"
                  >{{ s.name }}：{{ s.value }}</el-tag
                >
              </fieldset>
              <fieldset v-if="order.images != null" class="mgb15">
                <legend>{{ $t("product.images") }}</legend>
                <thumbnail :images="order.images" list></thumbnail>
              </fieldset>
              <fieldset
                v-if="order.remark != null && order.remark != ''"
                class="mgb15"
              >
                <legend>
                  {{ $t("text.remark") }}
                </legend>
                <raw-html :content="order.remark" type="richText" />
              </fieldset>
              <fieldset
                v-if="order.orderRemark != null && order.orderRemark != ''"
                class="mgb15"
              >
                <legend>
                  {{ $t("order.orderRemark") }}
                  <small class="orange">
                    ({{ $t("bargain.remarkExplain") }})
                  </small>
                </legend>
                <raw-html :content="order.orderRemark" />
              </fieldset>
              <fieldset v-if="order.cancelAt" class="mgb15">
                <legend>{{ $t("order.cancel") }}</legend>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.cancelAt')">
                      {{ order.cancelAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-form-item :label="$t('order.cancelReason')">
                      {{ order.cancelReason }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset v-if="order.returnAt" class="mgb15">
                <legend>{{ $t("order.return") }}</legend>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.returnAt')">
                      {{ order.returnAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-form-item :label="$t('order.returnReason')">{{
                      order.returnReason
                    }}</el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset
                v-if="
                  Permit.canActionsChargeEdition('orderDealView') &&
                  !['confirming', 'placed', 'pending'].includes(
                    order.workflowState
                  )
                "
                class="mgb15"
              >
                <legend>{{ $t("order.dealInfo") }}</legend>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.dealAt')">
                      {{ order.dealAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.operatorName')">
                      {{ order.operatorName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.dealType')">
                      <span v-if="order.dealType != null">
                        {{ $t("dealTypes." + order.dealType) }}
                      </span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="order.dealType == 'available'">
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('order.preparedDealAt')"
                      label-width="100px"
                    >
                      {{ order.dealtAt }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <div v-if="order.dealType == 'purchase'">
                  <el-row>
                    <el-col :span="8">
                      <el-form-item :label="$t('purchase.serialNo')">
                        {{ purchase.serialNo }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        :label="$t('purchase.workflowState')"
                        label-width="90px"
                      >
                        <state-label :state="purchase.workflowState">
                          {{ $t("purchaseStates." + purchase.workflowState) }}
                        </state-label>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('purchase.receiveQuantity')">
                        <span v-if="purchase.workflowState == 'finished'">
                          {{ purchase.quantity }}{{ purchase.unit }}
                        </span>
                        <span v-else>
                          {{ purchase.receiveQuantity }}{{ purchase.unit }}
                        </span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item
                        :label="$t('purchase.dealtAt')"
                        label-width="100px"
                      >
                        {{ order.dealtAt }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('menu.suppliers')">
                        {{ purchase.supplierName }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <el-row v-if="order.dealType == 'manufacture'">
                  <el-col
                    v-if="Permit.extendModels().includes('mes')"
                    :span="8"
                  >
                    <el-form-item :label="$t('order.mesWorkOrderState')">
                      <state-label :state="mesOrder.workflowState">
                        {{ $t("mesOrderStates." + mesOrder.workflowState) }}
                      </state-label>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.receiveQuantity')">
                      {{ order.receiveQuantity || 0 }}{{ order.unit }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>

              <fieldset v-if="reworks.length != 0" class="mgb15">
                <legend>{{ $t("order.reworkInfo") }}</legend>
                <vxe-table
                  :data="reworks"
                  id="reworksTable"
                  row-id="id"
                  ref="deliverInfosTable"
                  class="recordsTable"
                  size="mini"
                  resizable
                  round
                  auto-resize
                  highlight-hover-row
                  :scroll-y="{ enabled: false }"
                >
                  <vxe-table-column
                    field="voucher"
                    :title="$t('rework.voucher')"
                  >
                    <template v-slot="{ row }">
                      <thumbnail-text :srcs="row.voucher" :text="'凭证'" />
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="quantity"
                    :title="$t('text.quantity')"
                  />
                  <vxe-table-column field="remark" :title="$t('rework.remark')">
                    <template v-slot="{ row }">
                      <raw-html-limit-number
                        :content="row.remark"
                        :number="20"
                      />
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="createAt"
                    :title="$t('text.createAt')"
                  />
                  <vxe-table-column
                    field="ownerName"
                    :title="$t('rework.ownerName')"
                  />
                  <vxe-table-column
                    field="finishAt"
                    :title="$t('rework.finishAt')"
                  />
                  <vxe-table-column
                    field="finisherName"
                    :title="$t('rework.finisherName')"
                  />
                </vxe-table>
              </fieldset>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('text.log')" name="log">
          <div class="drawer-content with-tab">
            <div class="box">
              <el-timeline>
                <el-timeline-item
                  v-for="(log, index) in logs"
                  :key="index"
                  :timestamp="log.doAt"
                >
                  <span v-if="log.doBy != null" style="color: #909399">{{
                    log.doBy
                  }}</span>
                  <raw-html :content="log.content"></raw-html>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Currency from "@/components/Currency";
import RawHtml from "@/components/RawHtml";
import ThumbnailText from "@/components/ThumbnailText";
import Thumbnail from "@/components/Thumbnail";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import StateLabel from "@/components/StateLabel";
import Order from "@/api/order.js";
import OrderMes from "@/api/orderMes.js";

import Log from "@/api/log.js";
import Bargain from "@/api/bargain.js";
import Rework from "@/api/rework.js";
import Purchase from "@/api/purchase.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    Currency,
    RawHtml,
    ThumbnailText,
    Thumbnail,
    RawHtmlLimitNumber,
    StateLabel,
  },
  data() {
    return {
      activeName: "detail",
      order: { workflowState: "newly" },
      bargain: { settleType: null },
      logs: [],
      reworks: [],
      mesOrder: { workflowState: "newly" },
      purchase: { serialNo: null, supplierName: null, workflowState: "newly" },
    };
  },
  created() {
    const self = this;
    self.handleClickTab();
  },
  methods: {
    handleClickTab(tab, event) {
      if (this.activeName == "detail") {
        this.getOrder();
      }
      if (this.activeName == "log") {
        this.getLogs();
      }
    },
    getOrder() {
      const self = this;
      self.loading = true;
      Order.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.order = res.data.entity;
          self.getBargain();
          self.getReworks();
          if (self.Permit.canActionsChargeEdition("orderDealView")) {
            if (self.order.dealType === "purchase") {
              self.getPurchase();
            }
            if (
              self.order.dealType === "manufacture" &&
              self.Permit.extendModels().includes("mms")
            ) {
              self.getMesOrder();
            }
          }
        } else {
          self.sysError();
        }
        self.loading = false;
      });
    },
    getMesOrder() {
      const self = this;
      OrderMes.findByUuid({ uuid: self.order.uuid }).then(function (res) {
        if (res.status === 200) {
          self.mesOrder = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getPurchase() {
      const self = this;
      Purchase.findByOrderId(self.order.id).then(function (res) {
        if (res.status === 200) {
          self.purchase = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getReworks() {
      const self = this;
      Rework.findByEntityId(self.order.id, { entity: "Order" }).then(function (
        res
      ) {
        if (res.status === 200) {
          self.reworks = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getBargain() {
      const self = this;
      if (self.order.bargainId != null) {
        Bargain.findById(self.order.bargainId).then(function (res) {
          if (res.data.code === 200) {
            self.bargain = res.data.entity;
          } else {
            self.sysError();
          }
        });
      }
    },
    getLogs() {
      const self = this;
      Log.forEntity("Order", self.id).then(function (res) {
        self.logs = res.data;
      });
    },
  },
};
</script>